import classNames from 'classnames';
import styles from './style.module.scss';
import { useSelector } from 'react-redux';

const CustomInput = ({
    label,
    required,
    error,
    value,
    placeholder,
    type,
    onChange,
    notRequiredMargin,
    onKeyDown,
    CustomLabelStyle,
    CustomInputStyle,
    isPassword,
    readOnly,
    Icon,
    InputContainerStyle,
    optionText
}) => {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    return (
        <div className={classNames('position-relative w-100', notRequiredMargin ? '' : error ? 'mb-0' : 'mb-3')}>
            <div className="d-flex flex-column">
                <label className={classNames(`${theme}FontBlackThree`, styles.InputLabel, CustomLabelStyle && CustomLabelStyle)}>
                    {label} {!!required && <label className={styles.Asterik}>*</label>}
                    {!!optionText && <span className={classNames(styles.OptionText)}>{optionText}</span>}
                </label>
                <div className={classNames(styles.InputContainer, 'gap-2', InputContainerStyle && InputContainerStyle, `${theme}ModalBackground`) + ` ${readOnly ? styles.Readonly : ''}`}>
                    {Icon && <Icon />}
                    <input
                        type={type}
                        placeholder={placeholder}
                        className={classNames(`${theme}FontColor`, styles.InputStyle, CustomInputStyle && CustomInputStyle, `${theme}ModalBackground`) + ` ${readOnly ? styles.Readonly : ''}`}
                        value={value}
                        onChange={onChange}
                        onKeyDown={onKeyDown}
                        readOnly={readOnly}
                    />
                </div>
            </div>
            {!!error && <div className={styles.Error}>{error}</div>}
        </div>
    );
};

export default CustomInput;
